import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as e } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const t = e((a, r) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: r,
    ...a,
    image: (c) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...c,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_4127",
              width: 33,
              height: 32,
              x: 7,
              y: 8,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M17.02 17c.27-.79.2-1.58-.2-2.26-.58-1.02-1.86-1.74-3.69-2.09-.95-.19-1.6-.6-1.88-1.2-.23-.5-.13-.98.03-1.26q.255-.435.87-.6c.83-.22 2.01-.01 2.87.5 1.6.95 1.95 2.04 2.05 3.71.02.41.37.73.79.7.41-.02.73-.38.7-.79-.1-2.02-.62-3.63-2.76-4.91-1.22-.72-2.79-.99-4.02-.66-.81.21-1.43.66-1.8 1.3-.44.77-.48 1.78-.09 2.63.48 1.05 1.53 1.77 2.96 2.05 1.37.27 2.32.75 2.68 1.37.18.31.2.64.07 1.03-.06.19-.2.46-.66.62-.86.29-2.26.02-3.27-.64-1.38-.9-2.09-2.46-2.17-3.53a.757.757 0 0 0-.8-.7c-.42.03-.73.39-.7.81.11 1.48 1.03 3.5 2.85 4.68.99.64 2.2.99 3.29.99.46 0 .9-.06 1.29-.2.79-.27 1.34-.81 1.59-1.55M39.74 21.73c-.28-.71-.76-1.19-1.39-1.4-.82-.28-1.63-.23-2.34.15-1.01.54-1.76 1.7-2.22 3.45-.25.94-.71 1.56-1.33 1.79a1.4 1.4 0 0 1-1.25-.12c-.42-.28-.59-.78-.66-1.14-.16-.85.06-1.89.56-2.6 1.04-1.5 2.39-2.1 3.98-1.8.41.08.8-.19.88-.6a.75.75 0 0 0-.6-.88c-2.17-.4-4.12.45-5.49 2.42-.73 1.05-1.04 2.48-.8 3.73.17.93.62 1.66 1.3 2.11.74.5 1.75.6 2.62.28 1.08-.4 1.88-1.4 2.25-2.81.35-1.31.86-2.18 1.48-2.51.34-.18.72-.2 1.15-.05q.3.105.48.54c.28.71.24 2.03-.49 3.39-.68 1.27-2.17 1.89-3.88 1.63-.4-.06-.79.22-.85.63s.22.79.63.85c.34.05.67.08 1 .08 1.94 0 3.59-.9 4.43-2.49.81-1.57 1.03-3.4.54-4.65M23.48 30.36c-.7-.51-1.52-.7-2.38-.54-.77.15-1.37.6-1.71 1.28-.54 1.11-.34 2.71.57 4.49.48.93.53 1.8.14 2.38-.23.36-.6.55-1.01.52-1.36-.09-2.16-1.52-2.32-2.81-.22-1.76.32-3.08 1.55-3.83.35-.21.47-.67.26-1.03a.753.753 0 0 0-1.03-.26c-1.76 1.06-2.56 2.94-2.27 5.3.25 1.94 1.49 3.97 3.7 4.12.06 0 .12.01.18.01.88 0 1.69-.44 2.18-1.19.69-1.04.67-2.46-.06-3.89-.67-1.31-.88-2.49-.56-3.15.13-.26.34-.41.64-.47.45-.08.85 0 1.22.27.67.5 1.15 1.53 1.3 2.83.19 1.59-.62 3.11-1.45 3.86-.31.28-.33.75-.05 1.06s.75.33 1.06.05c1.14-1.03 2.18-3.03 1.93-5.15-.19-1.73-.86-3.1-1.89-3.85"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4127)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M.939.598h46.203v46.203H.939z" }) })
        ]
      }
    )
  }
));
t.displayName = "AgencyDarkSpotsIcon";
export {
  t as AgencyDarkSpotsIcon,
  t as default
};
//# sourceMappingURL=index.js.map
